module.exports = __webpack_public_path__ + "static/media/himanshu-text.8b0189be.png";